import superagent from 'superagent'
import { signGenerate, signGenerate2, compare } from '../assets/js/util'
// console.log(signGenerate({
//   os_version: '10.1',
//   token: '0WmFsPCSrTkJSm85uK6XClWe',
//   user_id: '150415',
//   app_id: '1',
//   app_version: '5.1.0',
//   device_id: '2C1D9882-42EE-44E0-8D7E-C7D904CD4B3D',
//   model: 'iPhone Simulator',
//   network: '5',
//   os: '1'
// }))

export const RequestControl = (rootState, params) => {
  // 为参数添加企业id
  if (rootState.common.enterprise_id) {
    params.enterprise_id = rootState.common.enterprise_id
  }
  if (rootState.duduApp.os === '1' || rootState.duduApp.os === '2') {
    params.os = rootState.duduApp.os
    params.app_id = rootState.duduApp.app_id
    params.app_version = rootState.duduApp.app_version
    params.model = rootState.duduApp.model
    params.network = rootState.duduApp.network
    params.os_version = rootState.duduApp.os_version
    params.user_id = rootState.userInfo.user_id
    params.token = rootState.userInfo.token
    if ((rootState.duduApp.os === '1' && compare(rootState.duduApp.app_version, '5.1.5') >= 0) || (rootState.duduApp.os === '2' && rootState.duduApp.app_version >= 52)) {
      params.token = encodeURIComponent(rootState.userInfo.token).replace(/%20/g, '+')
      params.sign = signGenerate2(params)
    } else {
      params.sign = signGenerate(params)
    }
  }
  return params
}

export const RequestCommonResponse = (rootState, res, callback) => {
  if (res.result === '0005') {
    rootState.common.reload_page = true
  } else {
    if (callback) {
      callback(res)
    }
  }
}

// 设置首页广告位
export const setBannerList = ({ commit, state, rootState }) => {
  var _params = {
    city: '深圳市',
    show_type: 2
  }
  _params = RequestControl(rootState, _params)
  superagent
  .post('/index.php/activities/banner')
  .send(_params)
  .type('form')
  .end(function (err, res) {
    if (err) {
      window.alert('网络异常，请稍后重试！')
    } else {
      res = JSON.parse(res.text)
      if (res.result === '0000') {
        commit('UPDATE_BANNER_LIST', res.data)
      } else {
        RequestCommonResponse(rootState, res)
      }
    }
  })
}

export const getBusLocation = ({ commit, state, rootState }, order_id) => {
  var _params = {
    order_id: order_id
  }
  return new Promise(function (resolve, reject) {
    superagent
    .post('/index.php/charter/order/bus_locations')
    .send(_params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        window.alert('网络异常，请稍后重试！')
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res)
        }
      }
    })
  })
}

// 获取车辆列表
export const setBusList = ({ commit, state, rootState }) => {
  var _params = {}
  var _arr = []
  var _midSiteArr = [] // 中间途径点
  var i = 0
  var len
  commit('UPDATE_LOADING', true)
  _params.os = state.duduApp.os ? state.duduApp.os : '0'
  if (state.order.type === 'business') {
    if (state.location.start_info) {
      _params.from_city = state.location.start_info.split('-')[1]
      _params.to_city = state.location.end_info ? state.location.end_info.split('-')[1] : ''
      _params.from_place_lng = state.location.start_info.split('-')[2]
      _params.from_place_lat = state.location.start_info.split('-')[3]
      _params.from_place = state.location.start_address
      _params.to_place_lng = state.location.end_info.split('-')[2]
      _params.to_place_lat = state.location.end_info.split('-')[3]
      _params.to_place = state.location.end_address
      _params.start_time = state.order.start_time.param
      if (state.location.way_address.length > 0) {
        _params.mid_sites = '1'
      } else {
        _params.mid_sites = '0'
      }
      switch (state.order.business_type) {
        case 'single':
          _params.charter_type = 0
          break
        case 'round':
          _params.charter_type = 1
          _params.back_time = state.order.end_time.param
          break
        case 'day':
          _params.charter_type = 2
          _params.back_time = state.order.end_time.param
          break
      }
      for (len = state.location.way_address.length; i < len; i++) {
        _arr.push(state.location.way_address[i].city)
        _midSiteArr.push(state.location.way_address[i])
      }
      _params.mid_cities = JSON.stringify(_arr)
      _params.mid_sites_list = JSON.stringify(_midSiteArr)
    }
  } else {
    if (state.location.szhk_start_info) {
      _params.from_city = state.location.szhk_start_info.split('-')[1]
      _params.to_city = state.location.szhk_end_info ? state.location.szhk_end_info.split('-')[1] : ''
      _params.from_place_lng = state.location.szhk_start_info.split('-')[2]
      _params.from_place_lat = state.location.szhk_start_info.split('-')[3]
      _params.from_place = state.location.szhk_start_address
      _params.to_place_lng = state.location.szhk_end_info.split('-')[2]
      _params.to_place_lat = state.location.szhk_end_info.split('-')[3]
      _params.to_place = state.location.szhk_end_address
      _params.start_time = state.order.start_time.param
      if (state.location.way_address.length > 0) {
        _params.mid_sites = '1'
      } else {
        _params.mid_sites = '0'
      }
      switch (state.order.szhk_type) {
        case 'single':
          _params.charter_type = 0
          break
        case 'round':
          _params.charter_type = 1
          _params.back_time = state.order.end_time.param
          break
      }
      for (len = state.location.szhk_way_address.length; i < len; i++) {
        _arr.push(state.location.szhk_way_address[i].city)
        _midSiteArr.push(state.location.szhk_way_address[i])
      }
      _params.mid_cities = JSON.stringify(_arr)
      _params.mid_sites_list = JSON.stringify(_midSiteArr)
    }
  }
  return new Promise(function (resolve, reject) {
    _params = RequestControl(rootState, _params)
    superagent
    // .post('/index.php/charter/mine/get_car_type')
    .post('/index.php/charter/mine/get_auto_car_type')
    .send(_params)
    .type('form')
    .end(function (err, res) {
      commit('UPDATE_LOADING', false)
      if (err) {
        reject(err)
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          commit('UPDATE_BUS_LIST', res.data)
          if (res.data.length > 0) {
            commit('UPDATE_CURRENT_BUS', res.data[0])
            // insert
            commit('UPDATE_CURRENT_BUS_INFO', {
              total_price: res.data[0].car_price,
              pricing_type: !!res.data[0].car_price
            })
            commit('UPDATE_BUS_LIST_ITEM_PRICE', {
              id: res.data[0].car_type_id,
              price: res.data[0].car_price
            })
          }
          // end insert
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res, reject)
        }
      }
    })
  })
}

// 查询并设置巴士价格（自动化报价）
export const setBusPrice = ({ commit, state, rootState }) => {
  var _charter_type
  var _type
  var _start_info = ''
  var _end_info = ''
  var _from_place = ''
  var _end_place = ''
  if (state.order.type === 'business') {
    _type = state.order.business_type
    _start_info = state.location.start_info.split('-')
    _from_place = state.location.start_address
    if (state.order.business_type !== 'day') {
      _end_info = state.location.end_info.split('-')
      _end_place = state.location.end_address
    }
  } else {
    _type = state.order.szhk_type
    _start_info = state.location.szhk_start_info.split('-')
    _end_info = state.location.szhk_end_info.split('-')
    _from_place = state.location.szhk_start_address
    _end_place = state.location.szhk_end_address
  }
  switch (_type) {
    case 'single':
      _charter_type = 0
      break
    case 'round':
      _charter_type = 1
      break
    case 'day':
      _charter_type = 2
      break
  }
  var _params = {
    from_place: _from_place,
    from_place_lng: _start_info[2],
    from_place_lat: _start_info[3],
    to_place: _end_place || '',
    to_place_lng: _end_info[2] || '',
    to_place_lat: _end_info[3] || '',
    charter_type: _charter_type,
    start_time: state.order.start_time.param,
    ignore_surcharge: 1,
    car_type_number: JSON.stringify([{
      car_type_id: state.order.current_bus.car_type_id,
      car_number: 1
    }])
  }
  var _mid_sites = state.order.type === 'business' ? state.location.way_address : state.location.szhk_way_address
  var _temp_arr = []
  for (var j = 0, len = _mid_sites.length; j < len; j++) {
    if (_mid_sites[j].lat) {
      _temp_arr.push(_mid_sites[j])
    }
  }
  _params.mid_sites = JSON.stringify(_temp_arr)
  var order_type = state.order.type === 'business' ? state.order.business_type : state.order.szhk_type
  // 只有往返有结束时间
  if (order_type === 'round') {
    _params.back_time = state.order.end_time.param
  }
  // 包天 则需要传包天时间
  if (order_type === 'day') {
    _params.day_num = state.order.day || ''
    _params.back_time = state.order.end_time.param
  }
  return new Promise(function (resolve, reject) {
    commit('UPDATE_LOADING', true)
    _params = RequestControl(rootState, _params)
    superagent
    .post('/index.php/charter/mine/get_order_price_info')
    .type('form')
    .send(_params)
    .end(function (err, res) {
      commit('UPDATE_LOADING', false)
      if (err) {
        reject(err)
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          // 设置默认费用明细
          res.data.contain_fee = ['车辆使用费', '司机服务费', '燃油费', '发票', '路桥费']
          res.data.uncontain_fee = ['司机餐饮费', '司机住宿费', '停车费']
          commit('UPDATE_CURRENT_BUS_INFO', res.data)
          commit('UPDATE_BUS_LIST_ITEM_PRICE', {
            id: state.order.current_bus.car_type_id,
            price: res.data.total_price
          })
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res, reject)
        }
      }
    })
  })
}

// 设置车辆价格为缓存价格
export const setCachePrice = ({ commit, state }, price) => {
  commit('UPDATE_CURRENT_BUS_INFO', {
    pricing_type: 1,
    total_price: price
  })
}

// 为了给后端添加缓存用的，查询巴士价格接口
export const searchBusPriceBeforeSubmit = ({ commit, state, rootState }, need_invoice) => {
  var _charter_type
  var _type
  var _start_info = ''
  var _end_info = ''
  var _from_place = ''
  var _end_place = ''
  if (state.order.type === 'business') {
    _type = state.order.business_type
    _start_info = state.location.start_info.split('-')
    _from_place = state.location.start_address
    if (state.order.business_type !== 'day') {
      _end_info = state.location.end_info.split('-')
      _end_place = state.location.end_address
    }
  } else {
    _type = state.order.szhk_type
    _start_info = state.location.szhk_start_info.split('-')
    _end_info = state.location.szhk_end_info.split('-')
    _from_place = state.location.szhk_start_address
    _end_place = state.location.szhk_end_address
  }
  switch (_type) {
    case 'single':
      _charter_type = 0
      break
    case 'round':
      _charter_type = 1
      break
    case 'day':
      _charter_type = 2
      break
  }
  var _selected_bus = []
  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
    var _item = state.order.bus_bill[i]
    _selected_bus[i] = {
      car_type_id: _item.car_type_id,
      car_number: _item.bus_num
    }
    if (_item.price) {
      _selected_bus[i].car_fee = _item.price
    }
  }
  var _params = {
    from_place: _from_place,
    from_place_lng: _start_info[2],
    from_place_lat: _start_info[3],
    charter_type: _charter_type,
    start_time: state.order.start_time.param,
    ignore_surcharge: 1,
    car_type_number: JSON.stringify(_selected_bus)
  }
  var _mid_sites = state.order.type === 'business' ? state.location.way_address : state.location.szhk_way_address
  var _temp_arr = []
  for (var j = 0, _len = _mid_sites.length; j < _len; j++) {
    if (_mid_sites[j].lat) {
      _temp_arr.push(_mid_sites[j])
    }
  }
  _params.mid_sites = JSON.stringify(_temp_arr)
  if (_charter_type !== 2) {
    _params.to_place = _end_place
    _params.to_place_lng = _end_info[2]
    _params.to_place_lat = _end_info[3]
  }
  var order_type = state.order.type === 'business' ? state.order.business_type : state.order.szhk_type
  // 只有往返有结束时间
  if (order_type === 'round') {
    _params.back_time = state.order.end_time.param
  }
  if (order_type === 'day') {
    _params.day_num = state.order.day
    _params.back_time = state.order.end_time.param
  }
  if (need_invoice) {
    _params.added_rule = '0003'
  }
  return new Promise(function (resolve, reject) {
    _params = RequestControl(rootState, _params)
    superagent
    .post('/index.php/charter/mine/get_order_price_info')
    .type('form')
    .send(_params)
    .end(function (err, res) {
      if (err) {
        reject(err)
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res, reject)
        }
      }
    })
  })
}

// 提交订单
export const submitOrder = ({ commit, state, rootState }, params) => {
  var _charter_type
  var _type
  var _start_info = ''
  var _end_info = ''
  var _from_place = ''
  var _end_place = ''
  if (state.order.type === 'business') {
    _type = state.order.business_type
    _start_info = state.location.start_info.split('-')
    _from_place = state.location.start_address
    _end_info = state.location.end_info.split('-')
    _end_place = state.location.end_address
  } else {
    _type = state.order.szhk_type
    _start_info = state.location.szhk_start_info.split('-')
    _end_info = state.location.szhk_end_info.split('-')
    _from_place = state.location.szhk_start_address
    _end_place = state.location.szhk_end_address
  }
  switch (_type) {
    case 'single':
      _charter_type = 0
      break
    case 'round':
      _charter_type = 1
      break
    case 'day':
      _charter_type = 2
      break
  }
  var _selected_bus = []
  for (var i = 0, len = state.order.bus_bill.length; i < len; i++) {
    var _item = state.order.bus_bill[i]
    _selected_bus[i] = {
      car_type_id: _item.car_type_id,
      car_number: _item.bus_num
    }
    if (_item.price) {
      _selected_bus[i].car_fee = _item.price
    }
  }
  var _params = {
    from_place: _from_place,
    from_province: _start_info[0],
    from_city: _start_info[1],
    from_place_lng: _start_info[2],
    from_place_lat: _start_info[3],
    form_area: '',
    is_need_invoice: params.is_need_invoice,
    charter_type: _charter_type,
    order_km: state.location.line_distance.distance.text.replace('公里', ''),
    start_time: state.order.start_time.param,
    ignore_surcharge: 1,
    car_type_number: JSON.stringify(_selected_bus),
    contact_name: params.contact_name,
    contact_phone: params.contact_phone,
    use_user: params.use_user,
    use_user_phone: params.use_user_phone,
    user_remark: params.user_remark,
    sub_type: params.sub_type,
    os: state.duduApp.os ? state.duduApp.os : '0',
    to_place: _end_place,
    to_province: _end_info[0],
    to_city: _end_info[1],
    to_place_lng: _end_info[2],
    to_place_lat: _end_info[3],
    to_area: ''
  }
  if (params.invoice_type) {
    _params.invoice_type = params.invoice_type
  }
  var _mid_sites = state.order.type === 'business' ? state.location.way_address : state.location.szhk_way_address
  var _temp_arr = []
  for (var j = 0, _len = _mid_sites.length; j < _len; j++) {
    if (_mid_sites[j].lat) {
      _temp_arr.push(_mid_sites[j])
    }
  }
  _params.mid_sites = JSON.stringify(_temp_arr)
  if (params.price) {
    _params.price = params.price
  }
  if (params.invoice_title) {
    _params.added_rule = '0003' // 兼容老接口的参数
    _params.invoice_title = params.invoice_title
    _params.invoice_address = params.invoice_address
    _params.invoice_contact_name = params.invoice_contact_name
    _params.invoice_contact_phone = params.invoice_contact_phone
  }
  if (_charter_type === 2 || _charter_type === 1) {
    _params.back_time = state.order.end_time.param
  }
  return new Promise(function (resolve, reject) {
    _params = RequestControl(rootState, _params)
    superagent
    .post('/index.php/charter/mine/create_order')
    .type('form')
    .send(_params)
    .end(function (err, res) {
      if (err) {
        reject(err)
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res, reject)
        }
      }
    })
  })
}

// 查询并设置订单详情
// params {order_id, is_open}
export const setOrderDetail = ({ commit, state, rootState }, params) => {
  params.user_id = state.userInfo.user_id
  // var _params = {
  //   user_id: state.userInfo.user_id,
  //   order_id: order_id
  // }
  return new Promise(function (resolve, reject) {
    params = RequestControl(rootState, params)
    superagent
    .post('/index.php/order/mine/get_charter_details')
    .type('form')
    .send(params)
    .end(function (err, res) {
      if (err) {
        reject(err)
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res, reject)
        }
      }
    })
  })
}

// 获取已开通城市
export const setOpenCityList = ({ commit, state, rootState }, isFormat) => {
  var _params = {
    format: isFormat || 0 // 是否进行格式话化，以字母的格式
  }
  return new Promise(function (resolve, reject) {
    _params = RequestControl(rootState, _params)
    superagent
    .post('/index.php/charter/mine/get_service_city')
    .type('form')
    .send(_params)
    .end(function (err, res) {
      if (err) throw err
      let data = JSON.parse(res.text).data
      if (!isFormat) {
        commit('UPDATE_OPEN_CITY_LIST', data)
      } else {
        commit('UPDATE_OPEN_CITY_LIST_FORMAT', data)
      }
    })
  })
}

// 获取用户当前价格下适用的优惠券列表
export const getUserCoupon = ({ commit, state, rootState }, price) => {
  var _params = {
    user_id: state.userInfo.user_id,
    type: '8',
    pay_price: price || state.order.recent_price
  }
  if (state.duduApp.os) {
    _params.os = state.duduApp.os
  }
  return new Promise(function (resolve, reject) {
    _params = RequestControl(rootState, _params)
    superagent
    .post('/index.php/users/vouchers/get_able_vouchers')
    .send(_params)
    .type('form')
    .end(function (err, res) {
      if (err) throw err
      let _res = JSON.parse(res.text)
      if (_res.result === '0000') {
        resolve(_res)
      } else {
        RequestCommonResponse(rootState, res, reject)
      }
    })
  })
}

// 订单绑定优惠券
export const bindCoupon = ({ commit, state, rootState }, params) => {
  var _params = {
    user_id: state.userInfo.user_id,
    order_id: params.order_id,
    use_voucher_type: 2,
    voucher_code: params.coupon_id
  }
  return new Promise(function (resolve, reject) {
    _params = RequestControl(rootState, _params)
    superagent
    .post('/index.php/charter/mine/check_pay_order')
    .type('form')
    .send(_params)
    .end(function (err, res) {
      if (err) {
        reject(err)
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res, reject)
        }
      }
    })
  })
}

// 取消订单
export const sendCancelOrder = ({ commit, state, rootState }, order_id) => {
  var _params = {
    user_id: state.userInfo.user_id,
    order_id: order_id
  }
  return new Promise(function (resolve, reject) {
    _params = RequestControl(rootState, _params)
    commit('UPDATE_LOADING', true)
    superagent
    .post('/index.php/charter/mine/cancel_orde')
    .type('form')
    .send(_params)
    .end(function (err, res) {
      commit('UPDATE_LOADING', false)
      if (err) {
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res, reject)
        }
      }
    })
  })
}

// 取消订单扣手续费弹窗
export const serviceCost = ({ commit, state, rootState }, params) => {
  var _params = {
    user_id: state.userInfo.user_id,
    order_id: params.order_id,
    city_name: params.city_name
  }
  return new Promise(function (resolve, reject) {
    _params = RequestControl(rootState, _params)
    superagent
    .post('/index.php/charter/mine/new_cancel_order')
    .type('form')
    .send(_params)
    .end(function (err, res) {
      if (err) {
        reject(err)
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res, reject)
        }
      }
    })
  })
}
export const clearSelectedInfo = ({ commit }) => {
  commit('RESET_SELECTED_BUS')
  commit('UPDATE_SELECT_COUPON', {
    vouchers_Identifier: null,
    vouchers_money: null
  })
}

// 清空所有临时下单数据
export const clearOrder = ({ commit }) => {
  commit('UPDATE_START_TIME', '')
  commit('UPDATE_END_TIME', '')
  commit('UPDATE_START_ADDRESS', '')
  commit('UPDATE_START_INFO', '')
  commit('UPDATE_END_ADDRESS', '')
  commit('UPDATE_END_INFO', '')
  commit('UPDATE_SZHK_START_ADDRESS', '')
  commit('UPDATE_SZHK_START_INFO', '')
  commit('UPDATE_SZHK_END_ADDRESS', '')
  commit('UPDATE_SZHK_END_INFO', '')
  commit('UPDATE_WAY_ADDRESS', {})
  commit('UPDATE_WAY_INFO', '')
  commit('UPDATE_SZHK_WAY_ADDRESS', {})
  commit('UPDATE_SZHK_WAY_INFO', '')
  commit('RESET_SELECTED_BUS')
  commit('UPDATE_SELECT_COUPON', {
    vouchers_Identifier: null,
    vouchers_money: null
  })
  commit('UPDATE_ORDER_TYPE', 'business')
  commit('UPDATE_BUSINESS_TYPE', 'round')
  commit('UPDATE_SZHK_TYPE', 'round')
  commit('UPDATE_ORDER_RANGE', '')
  commit('UPDATE_ORDER_DAY', '')
}

// 加载七鱼文件
export const initQiYuScript = ({ commit }) => {
  if (!(window.ysf && window.ysf.ROOT)) {
    var _script = document.createElement('script')
    _script.src = 'https://qiyukf.com/script/64ac1e6257cc02795de5a16228ed6a9a.js'
    document.body.appendChild(_script)
  }
}

// 公司发票抬头模糊搜索
// export const searchInvoice = ({ commit, state, rootState }, params) => {
//   return new Promise(function (resolve, reject) {
//     superagent
//       .get('/index.php/charter/mine/get_invoice_title?buyer_title=' + params)
//       .end(function (err, res) {
//         if (err) {
//           reject(err)
//         } else {
//           res = JSON.parse(res.text)
//           if (res.result === '0000') {
//             resolve(res)
//           } else {
//             RequestCommonResponse(rootState, res, reject)
//           }
//         }
//       })
//   })
// }

// 获取发票信息
export const getInvoiceInfo = ({ commit, state, rootState }) => {
  var _params = {}
  return new Promise(function (resolve, reject) {
    _params = RequestControl(rootState, _params)
    superagent
    .post('/index.php/charter/mine/get_invoice_info')
    .type('form')
    .send(_params)
    .end(function (err, res) {
      if (err) {
        reject(err)
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res, reject)
        }
      }
    })
  })
}

// 保存发票信息
export const saveInvoiceInfo = ({ commit, state, rootState }, params) => {
  return new Promise(function (resolve, reject) {
    var _params = RequestControl(rootState, params)
    superagent
    .post('/index.php/charter/mine/save_invoice_info')
    .type('form')
    .send(_params)
    .end(function (err, res) {
      if (err) {
        reject(err)
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          resolve(res)
        } else {
          RequestCommonResponse(rootState, res, reject)
        }
      }
    })
  })
}

// 再下一单，获取订单详情
export const getOrderDetail = ({ commit, state, rootState }, order_id) => {
  var _params = {
    order_id: order_id
  }
  _params = RequestControl(rootState, _params)
  superagent
    .post('/index.php/order/mine/get_charter_details')
    .send(_params)
    .type('form')
    .end(function (err, res) {
      if (err) {
        window.alert('网络异常，请稍后重试！')
      } else {
        res = JSON.parse(res.text)
        if (res.result === '0000') {
          if (parseInt(res.data.sub_type) === 0) {
            commit('UPDATE_ORDER_TYPE', 'business')
          } else if (parseInt(res.data.sub_type) === 1) {
            commit('UPDATE_ORDER_TYPE', 'szhk')
          }
          if (parseInt(res.data.charter_type) === 0) {
            commit('UPDATE_BUSINESS_TYPE', 'single')
            commit('UPDATE_SZHK_TYPE', 'single')
          } else if (parseInt(res.data.charter_type) === 1) {
            commit('UPDATE_BUSINESS_TYPE', 'round')
            commit('UPDATE_SZHK_TYPE', 'round')
          } else if (parseInt(res.data.charter_type) === 2) {
            commit('UPDATE_BUSINESS_TYPE', 'day')
          }
          var start_info = {'province': res.data.from_province, 'city': res.data.from_city, 'lng': res.data.from_place_lng, 'lat': res.data.from_place_lat}
          var end_info = {'province': res.data.to_province, 'city': res.data.to_city, 'lng': res.data.to_place_lng, 'lat': res.data.to_place_lat}
          var way_address = []
          if (res.data.mid_sites.length > 0) {
            for (var i = 0, len = res.data.mid_sites.length; i < len; i++) {
              if (res.data.mid_sites[i].address) {
                way_address.push(res.data.mid_sites[i])
              }
            }
          }
          commit('UPDATE_START_TIME', '')
          commit('UPDATE_END_TIME', '')
          if (parseInt(res.data.sub_type) === 0) {
            commit('UPDATE_START_ADDRESS', res.data.from_place)
            commit('UPDATE_START_INFO', start_info)
            commit('UPDATE_END_ADDRESS', res.data.to_place)
            commit('UPDATE_END_INFO', end_info)
            commit('UPDATE_WAY_INFO', res.data.mid_sites)
            window.localStorage.setItem('way_address', JSON.stringify(way_address))
          } else if (parseInt(res.data.sub_type) === 1) {
            commit('UPDATE_SZHK_START_ADDRESS', res.data.from_place)
            commit('UPDATE_SZHK_START_INFO', start_info)
            commit('UPDATE_SZHK_END_ADDRESS', res.data.to_place)
            commit('UPDATE_SZHK_END_INFO', end_info)
            commit('UPDATE_SZHK_WAY_INFO', res.data.mid_sites)
            window.localStorage.setItem('szhk_way_address', JSON.stringify(way_address))
          }
          window.localStorage.setItem('bus_selected_list', JSON.stringify(res.data.car_type_info))
          var user_message = {'invoice_need': res.data.invoice_need, 'is_use_user': res.data.is_use_user, 'contact_name': res.data.contact_name, 'contact_phone': res.data.contact_phone, 'use_user': res.data.use_user, 'use_user_phone': res.data.use_user_phone, 'user_remark': res.data.user_remark}
          window.localStorage.setItem('user_message', JSON.stringify(user_message))
        } else {
          RequestCommonResponse(rootState, res)
        }
      }
    })
}




// WEBPACK FOOTER //
// ./src/store/actions.js